import axiosPrivate from "./axiosPrivate";

const getSueldos = () => {
    return axiosPrivate.get("sueldo-planilla");
};

const storeSueldo = (data) => {
    return axiosPrivate.post("sueldo-planilla", data);
};

const deleteSueldo = (id) => {
    return axiosPrivate.delete(`sueldo-planilla/${id}`);
};

export default {
    getSueldos,
    storeSueldo,
    deleteSueldo
};
